export const createAccessMap = (rawAccess = []) => {
  const map = {};

  rawAccess.forEach(({ section, permissions }) => {
    if (!section) return;
    map[section] = {};

    permissions.forEach((permission) => {
      if (typeof permission !== 'string') return;
      map[section][permission.toLowerCase()] = true;
    });
  });

  return map;
};

export const hasPermission = (
  accessMap,
  sections,
  permissions,
  requireAll = false,
) => {
  const sectionArray = Array.isArray(sections)
    ? sections
    : [sections];

  const permissionArray = Array.isArray(permissions)
    ? permissions
    : [permissions];

  return sectionArray.some((section) => {
    if (requireAll) {
      return permissionArray.every((permission) => {
        if (!permission || typeof permission !== 'string') {
          return false;
        }

        return !!accessMap?.[section]?.[
          permission.toLowerCase()
        ];
      });
    }

    return permissionArray.some((permission) => {
      if (!permission || typeof permission !== 'string') {
        return false;
      }

      return !!accessMap?.[section]?.[
        permission.toLowerCase()
      ];
    });
  });
};